import { EmptyState, LoadError, NoResults, TableSkeleton, type TableSkeletonColumn } from "@dehub/theme";
import type { ReactElement, ReactNode } from "react";

type Props = {
  /** Анхны ачаалал (өгөгдөл хараахан ирээгүй). */
  loading?: boolean;
  /** Хүсэлт амжилтгүй болсон бол алдаа (код нь байвал mono-оор харагдана). */
  error?: unknown;
  onRetry?: () => void;
  /** Мөр байхгүй. */
  empty: boolean;
  /** Хайлт/шүүлтүүр идэвхтэй үед NoResults, үгүй бол EmptyState. */
  filtered?: boolean;
  query?: string;
  onClear?: () => void;
  /** Skeleton-ий багана: тоо эсвэл багана тус бүрийн тайлбар. */
  columns?: number | TableSkeletonColumn[];
  emptyTitle?: ReactNode;
  emptyDescription?: ReactNode;
  emptyAction?: ReactNode;
};

function errorCode(error: unknown): string | number | undefined {
  const e = error as { status?: number | string; code?: number | string; response?: { status?: number } } | undefined;
  return e?.status ?? e?.response?.status ?? e?.code;
}

/**
 * DeHUB UI стандартын жагсаалтын 4 төлөв (NoAccess-ийг usePermission өгнө):
 * ачаалж байна (TableSkeleton), алдаа (LoadError + дахин оролдох), өгөгдөлгүй (EmptyState), үр дүнгүй (NoResults).
 * Мөр байвал null буцаана, тэгэхэд хуудас өөрийн хүснэгтээ зурна. Хүснэгтийн толгой зөвхөн мөртэй үед зурагдана.
 */
export function ListStates({
  loading,
  error,
  onRetry,
  empty,
  filtered,
  query,
  onClear,
  columns = 5,
  emptyTitle,
  emptyDescription,
  emptyAction,
}: Props): ReactNode {
  if (!empty) return null;
  if (loading) return <TableSkeleton rows={6} columns={columns} />;
  if (error) return <LoadError code={errorCode(error)} onRetry={onRetry} />;
  if (filtered) return <NoResults query={query || undefined} onClear={onClear} />;
  return <EmptyState title={emptyTitle} description={emptyDescription} action={emptyAction} />;
}

/**
 * `<ListStates/>` element нь үргэлж объект тул `??` / `? :`-аар хүснэгт рүү унахгүй.
 * Энэ туслах нь element-ийг шууд үнэлж, мөр байвал жинхэнэ null буцаана (ListStates hook ашигладаггүй).
 */
export function resolveListStates(el: ReactElement<Props>): ReactNode {
  return ListStates(el.props);
}
